/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
 */

/**
 * Find the list of data-hrefs of text-containing passages (qti-includes) in the current rendered item
 * Depends on the DOM already being loaded
 * @param {Object} itemRunnerData
 * @returns {String[]}
 */
export function getTextItemPassagesHrefs(itemRunnerData = {}) {
    const passageHrefs = Object.keys(
        (itemRunnerData &&
            itemRunnerData.itemData &&
            itemRunnerData.itemData.assets &&
            itemRunnerData.itemData.assets.xinclude) ||
            {}
    );

    // We only want to know about passages which are: 1. currently rendered; 2. not textless
    return passageHrefs.filter(href => {
        const domNode = document.querySelector(`.qti-include[data-href="${href}"]`);
        return domNode && Array.from(domNode.childNodes).some(child => child.nodeType === child.TEXT_NODE);
    });
}
